module.exports = __webpack_public_path__ + "img/Group 56578backArrow.826a48b0.svg";